module.exports = __webpack_public_path__ + "img/symbol_6.02047d6a.png";